import React from 'react'
import Avatar from 'components/profile/Avatar'
import { UserAvatarProps } from '../main-nav-bar/types' // Renamed type
import { getAvatarInitials } from './utils'

const UserAvatar: React.FC<UserAvatarProps> = ({ user, size = 'md', className }) => {
  if (!user) return null

  return user.avatar ? (
    <Avatar url={user.avatar} size={size} />
  ) : (
    <span className={className}>{getAvatarInitials(user)}</span>
  )
}

export default UserAvatar
